import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "56",
  height: "40",
  viewBox: "0 0 56 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("rect", {
      width: "56",
      height: "40",
      rx: "8",
      fill: "#0A0909"
    }, null, -1),
    _createElementVNode("path", {
      d: "M9.632 28V11.2H15.368C17.336 11.2 18.952 11.552 20.216 12.256C21.496 12.944 22.44 13.92 23.048 15.184C23.672 16.432 23.984 17.904 23.984 19.6C23.984 21.296 23.672 22.776 23.048 24.04C22.44 25.288 21.496 26.264 20.216 26.968C18.952 27.656 17.336 28 15.368 28H9.632ZM12.704 25.36H15.224C16.632 25.36 17.744 25.136 18.56 24.688C19.376 24.224 19.96 23.568 20.312 22.72C20.664 21.856 20.84 20.816 20.84 19.6C20.84 18.4 20.664 17.368 20.312 16.504C19.96 15.64 19.376 14.976 18.56 14.512C17.744 14.048 16.632 13.816 15.224 13.816H12.704V25.36Z",
      fill: "#EEEEE8"
    }, null, -1),
    _createElementVNode("circle", {
      cx: "42",
      cy: "12",
      r: "6",
      fill: "#EEEEE8"
    }, null, -1),
    _createElementVNode("circle", {
      cx: "42",
      cy: "28",
      r: "6",
      fill: "white"
    }, null, -1)
  ])))
}
export default { render: render }